// extracted by mini-css-extract-plugin
export default {"wrapperQuotes":"Desciption_wrapperQuotes__+1ruF","ownerBlock":"Desciption_ownerBlock__cdYYi","quotesStyle":"Desciption_quotesStyle__70sqP"};